module.exports = __webpack_public_path__ + "static/media/Icon_SW_Inactive.cb3921c6.png";